import { useEffect, useState } from "react";
import { useDealer } from "../../../../../tools/api";
import { Table } from "antd";
import { NotFound } from "../../../../../sources/svg/svg";
import { convertCurrencyToToman, convertToJalaliWithTime } from "../../../../../tools/tools";

const PackageHistory = ({ sppurchaseid = 0 }) => {
  const { queryEPPurchaseBySPPurchaseId } = useDealer();
  const [listPackage, setListPackage] = useState([]);

  //state current page show Records
  const [currentPage, setCurrentPage] = useState(0);
  // state totalRecord
  const [totalRecord, setTotalRecord] = useState(0);

  const [isLoadingList, setIsLoadingList] = useState(true);

  useEffect(() => {
    const initial = async () => {
      try {
        //#region packages
        setIsLoadingList(true);
        const payloadPackage = {
          SPPurchaseId: sppurchaseid,
          search: {
            sort: "",
            filter: "",
            entriesperpage: 10,
            page: currentPage === 0 ? 0 : currentPage - 1,
            totalrowcount: 0,
          },
        };
        const responsePackages = await queryEPPurchaseBySPPurchaseId(payloadPackage);
        if (responsePackages) {
          setListPackage(responsePackages.Result);
          setTotalRecord(responsePackages?.searchconfigmodel?.totalrowcount);
        }
        setIsLoadingList(false);
        //#endregion packages
      } catch (error) {
        setIsLoadingList(false);
        console.log(error?.message);
      }
    };
    if (sppurchaseid) initial();
  }, [sppurchaseid, currentPage]);
  return (
    <>
      <div className="holder-table" style={{ marginTop: "3rem" }}>
        <Table
          className="tbl-normal"
          loading={isLoadingList}
          columns={[
            {
              title: "نام بسته",
              dataIndex: "productname",
              key: "productname",
              width: 150,
            },
            {
              title: "مبلغ",
              dataIndex: "chargamount",
              key: "chargamount",
              width: 150,
            },
            {
              title: "مالیات",
              dataIndex: "tax",
              key: "tax",
              width: 150,
            },
            {
              title: "تاریخ",
              dataIndex: "purchasedate",
              key: "purchasedate",
              width: 150,
            },
            {
              title: "درگاه خرید",
              dataIndex: "paidtype",
              key: "paidtype",
              width: 150,
            },
            {
              title: "کاربر",
              dataIndex: "username",
              key: "username",
              width: 150,
            },
            {
              title: "وضعیت درخواست",
              dataIndex: "state",
              key: "state",
              width: 150,
            },
          ]}
          locale={{
            emptyText: (
              <>
                <NotFound text={"رکوردی یافت نشد."} />
              </>
            ),
          }}
          scroll={{ y: "100%" }}
          pagination={{
            className: "page-pagination",
            // position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
            onChange: (page) => {
              setCurrentPage(page);
            },
            pageSize: 10,
            align: "start",
            current: currentPage === 0 ? 1 : currentPage,
            total: totalRecord,
            showSizeChanger: false,
          }}
          dataSource={listPackage.map((item, key) => ({
            key: key,
            productname: item?.productname,
            chargamount: convertCurrencyToToman(item?.chargamount),
            tax: convertCurrencyToToman(item?.tax),
            purchasedate: convertToJalaliWithTime(item?.purchasedate),
            paidtype: item?.paidtype,
            username: item?.username || "-",
            state: item?.state,
          }))}
        />
      </div>
    </>
  );
};

export default PackageHistory;
